export default __webpack_public_path__ + "static/media/Rectangle 5.aa56f4bf.png";